import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Icon, Fab, Button, LinearProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextareaAutosize } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import BackspaceIcon from '@material-ui/icons/Backspace';
import FavoriteIcon from '@material-ui/icons/Favorite'
import { Language, Smartphone, Email, LocationOn, StoreMallDirectory } from '@material-ui/icons'
import CommentList from './comment-list.js'
import LikedList from './Liked-list';
import ProductList from './product-list.js'
import {
    Link
} from 'react-router-dom';
function capitalize(string) {
  if (typeof string == undefined) return;
  var firstLetter = string[0] || string.charAt(0);
  return firstLetter ? firstLetter.toUpperCase() + string.slice(1) : '';
}

function enumToString(e) {
  return e && e.toLowerCase().split('_').map(capitalize).join(' ');
}

function App(props) {
  const { id } = props.match.params;
  const [sponsor, setSponsor] = useState(undefined);
  const [products, setProducts] = useState(undefined);
  const [rate, setRate] = useState(undefined);
  const [rateList, setRateList] = useState(undefined);

  const [showRatingDialog, setShowRatingDialog] = useState(false);
  const [showInfo, setShowInfo] = useState(null);
  const [showLikedDialog, setShowLikedDialog] = useState(false);

  function loadSponsor() {
    axios.get(`/api/sponsors/${id}`).then(function (response) {
      if (response.status === 200) {
        setSponsor(response.data)
        axios.get(`/api/products?groupId=`+response.data.businessInfo._id).then(function(response2){
            if(response2.status === 200){
                setProducts(response2.data);
            }
        });
      }
    }).catch(
                 function (error) {
                  if(error.response && error.response.data && error.response.data.type === 'authentication.missing'){
                       var _redirectUrl = encodeURIComponent(window.location.href);
                       window.location.href = '/signin.html?redirect='+_redirectUrl;
                  }
                   return Promise.reject(error)
                 }
               );;
  }

  useEffect(() => {
    loadRate();
    loadRateList();
  }, [sponsor]);

  function loadRate() {
    if (sponsor) {
      axios.get(`/api/ratings/@myrating/${sponsor.businessInfo._id}`).then(function (response) {
        if (response.status === 200) {
            if(response.data){
              setRate(response.data);
            }
        }
      });
    }
  }

  function loadRateList() {
    if (sponsor) {
      axios.get(`/api/ratings/@entity/${sponsor.businessInfo._id}`).then(function (responnse) {
        if (responnse.status === 200) {
          setRateList(responnse.data);
        }
      });
    }
  }

  function postRating(changeRate) {
    axios.put(`/api/sponsors/${id}/@rating`, { comment: (rate&&rate.comment), point: changeRate ? (rate && rate.point > 0 ? 0 : 1) : rate && rate.point }).then(function (responnse) {
      loadRate();
      loadRateList();
      loadSponsor();
    });
  }

  function handleClose() {
    setShowRatingDialog(false);
  }

  function handleSubmitComment() {
    postRating();
    setShowRatingDialog(false);
  }

  function renderRate(rate) {
    return rate.comment;
  }
  useEffect(() => {
    loadSponsor();
  }, [id]);


  if (sponsor === undefined) {
    return <LinearProgress style={{ marginTop: '150px' }} />
  }

  const couponSection = sponsor.businessInfo.coupons && (<div className="ka-section">
    {sponsor.businessInfo.coupons.map(coupon => (<div>
      <div style={{ fontWeight: 400, textAlign: 'center' }}>{coupon.title}</div>
      <div style={{whiteSpace: 'pre-line'}}>{coupon.description}</div>
    </div>))}
  </div>);



  const ratingDialog = (<Dialog fullWidth open={showRatingDialog} aria-labelledby="form-dialog-title">
    <DialogTitle id="form-dialog-title">Review</DialogTitle>
    <DialogContent>
      <div>
        <TextareaAutosize
          rowsMax={10}
          rowsMin={3}
          placeholder="Leave your review"
          value={rate && rate.comment}
          onChange={(e) => setRate({ ...rate, comment: e.target.value })}
          style={{ width: '100%' }}
        />
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary" showLikedDialog>
        Cancel
    </Button>
      <Button onClick={handleSubmitComment} color="primary" showLikedDialog>
        Submit
    </Button>
    </DialogActions>
  </Dialog>);

  const infoDialog = (showInfo && <Dialog fullWidth open={showInfo} aria-labelledby="form-dialog-title"><DialogContent style={{textAlign: 'center'}}>
        <a style={{textDecoration: 'none', color: '#F07300'}} href={showInfo.link}>{showInfo.text}</a>
        <DialogActions>
          <Button onClick={() => setShowInfo(null)} color="primary" style={{textDecoration: 'none', color: '#F07300'}}>
          Cancel
          </Button>
        </DialogActions>
        </DialogContent></Dialog>);


    const likedDialog = (<Dialog fullWidth open={showLikedDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Your Community Members Who Like the Business</DialogTitle>
        <DialogContent>
        <div>
    {rateList && <LikedList items={rateList.filter(item => item.point> 0)} />}
        </div>
    </DialogContent>
    <DialogActions>
        <Button onClick={() => setShowLikedDialog(false)} color="primary" style={{textDecoration: 'none', color: '#F07300'}}>
        Cancel
        </Button>
        </DialogActions>
        </Dialog>);

  const addressLink = (sponsor.businessInfo.addresses && sponsor.businessInfo.addresses[0]) ?
	(sponsor.businessInfo.addresses[0].street + ', ' + sponsor.businessInfo.addresses[0].city + ', ' 
	+ sponsor.businessInfo.addresses[0].state + ' ' + sponsor.businessInfo.addresses[0].zip): '';

  function getColor(a){
    return a ? 'inherit': '#999';
  }
  
  function getIconStyle(a){
    return { flex: 1, textAlign: 'center',color: getColor(a), textDecoration: 'none'};
  }

  function getRecommendationCount(sponsor){
    if(!sponsor.school){
        if(!rateList)
            return 0;
        else
            return rateList.filter(item => item.point > 0).length;
    }else{
        return sponsor.recommendCount;
    }
  }
  return (
    <div>
      <div className="ka-section">
        <div className="detail-header">
          <img className="detail-header-logo" height="60" style={{width: '60px'}} alt='logo' src={sponsor.businessInfo.logo90||sponsor.businessInfo.logo} />
          <div style={{ flex: 1 }}>
            <div className="detail-header-title">{sponsor.businessInfo.name}</div>
            <div className="detail-header-category">{enumToString(sponsor.businessInfo.category)}</div>
            {sponsor.ownedByParent && <span className="ka-label">Parent Owned</span>}
          </div>
        </div>
        <div style={{ flex: 1, display: 'flex', marginTop: '10px', fontSize: '.8em', color: '#F07300' }}>
          <div style={getIconStyle(sponsor.businessInfo.link)} onClick={() => setShowInfo({link: '/pv?sponsorId=' + sponsor._id, text: sponsor.businessInfo.link})}>
              <Language />
          <div>Link</div>
        </div>
        <div style={getIconStyle(addressLink)} onClick={() => 	setShowInfo({link: ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPad") != -1) || (navigator.platform.indexOf("iPod") != -1)) ? "http://maps.apple.com?q="+addressLink : "http://maps.google.com/maps?q="+addressLink, text: addressLink}) }>
          <LocationOn />
          <div>Map</div>
        </div>
        <div style={getIconStyle(sponsor.businessInfo.phone)} onClick={() => setShowInfo({ link: 'tel:' + sponsor.businessInfo.phone, text: sponsor.businessInfo.phone})}>
          <Smartphone />
          <span style={{display: 'block'}}>Phone</span>
        </div>
        <div style={getIconStyle(sponsor.businessInfo.email)} onClick={() => setShowInfo({ link: 'mailto:' + sponsor.businessInfo.email, text: sponsor.businessInfo.email})}>
          <Email />
          <span style={{display: 'block'}}>Email</span>
        </div>
      </div>
    </div>

    <div className="ka-section" style={{ textAlign: 'center' }}>
      <div><span style={{textDecoration: 'none', color: getRecommendationCount(sponsor) > 0?'#F07300': 'inherit'}} onClick={() => setShowLikedDialog(getRecommendationCount(sponsor)  > 0) }> {getRecommendationCount(sponsor)} {getRecommendationCount(sponsor) > 1 ? 'members':"member"}</span> like this business</div>
      <Fab color={(rate && rate.point > 0) ? 'secondary' : 'default'} size="small" aria-label="like">
        <FavoriteIcon onClick={() => postRating(true)} />
      </Fab>
    </div>

      { couponSection }
      { infoDialog }
                { likedDialog }

    <div className="ka-section">
                  {products &&  <ProductList items={products} />}
    </div>
  <div className="ka-section">
                {rateList &&  <CommentList items={rateList.filter(item => !!item.comment)} />}
  </div>
    <Fab color="primary" aria-label="add" style={{ right: '10px', position: "fixed", bottom: '100px', backgroundColor: '#F07300' }}>
      <AddIcon onClick={() => setShowRatingDialog(true)} />
    </Fab>
      { ratingDialog }
    </div>
  );
}

export default App;
